<!-- The normal outlet for the public pages -->
<router-outlet *ngIf="!loggedIn()"></router-outlet>

<!-- The component wich holds the master template layout -->
<app-layout *ngIf="loggedIn()"></app-layout>
